import HttpService from "../HttpService";

export const makeOrder = async ({ id, group_order_items, payment_method_id }) => {
    const res = await HttpService({
        method: 'POST',
        url: '/api/v2/group_orders/' + id + '/group_order_items',
        data: {
            group_order_items,
            payment_method_id
        }
    });

    return res.data;
};

export const deleteMyOrder = async ({ id, group_order_items }) => {
    const res = await HttpService({
        method: 'DELETE',
        url: '/api/v2/group_orders/' + id + '/group_order_items/cancel_my_order',
        data: {
            group_order_items
        }
    });

    return res.data;
};

export const fetchMyProducts = async (id) => {
    const res = await HttpService({
        method: 'GET',
        url: '/api/v2/group_orders/' + id + '/my_order'
    });

    return res.data;
};